let $ = jQuery;

$(function () {
    //$('.ug-hero').each(function () {
    //    var gbButton = this.find("a.gb-button").parent();

    //    if (gbButton) {

    //    }
    //});

});